import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AdminService } from 'app/admin/admin.service';
import { INofesh } from 'app/nofesh/model/nofesh';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { ENofeshType } from 'app/shared/enums/enofesh-type.enum';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';

@Component({
  selector: 'app-add-nofesh',
  templateUrl: './add-nofesh.component.html',
  styleUrls: ['./add-nofesh.component.css']
})
export class AddNofeshComponent implements OnInit {
  newNofesh: FormGroup = this._formBuilder.group({
    nofesh: this._formBuilder.group({
      isTentativi: [0, [Validators.required, Validators.min(1)]],
      nofeshMekushar: 0, // TODO: add validator
      machzor: [0, [Validators.required, Validators.min(1), Validators.max(2)]],
      status: [0, [Validators.required, Validators.min(1), Validators.max(2)]],
      year: ["", [Validators.required, Validators.min(new Date().getFullYear() - 1), Validators.max(new Date().getFullYear() + 2)]],
      title: ["", Validators.required],
      type: [ENofeshType.None, [Validators.min(ENofeshType.NofeshPnim), Validators.max(ENofeshType.MishpachotChul)]],
      fromDate: ["", Validators.required],
      toDate: ["", Validators.required],
      totalPeople: [1000, [Validators.required, Validators.min(1)]],
      maxPeopleHamtana: ["", Validators.required],
      totalRooms: [20, [Validators.required, Validators.min(1)]],
      maxRoomsHamtana: ["", Validators.required],
      boardType: [2, [Validators.min(1), Validators.max(3)]],
      companyName: ["", Validators.required],
      companyWebsite: "",
      hotelName: ["", Validators.required],
      hotelRate: ["", [Validators.required, Validators.min(1), Validators.max(5)]],
      heara1: ["", Validators.maxLength(250)],
      heara2: ["", Validators.maxLength(250)],
      heara3: ["", Validators.maxLength(250)],
      isSyllabusUploaded: true,
      childMinAge: [2, [Validators.min(2), Validators.max(9)]],
      childMaxAge: [12, [Validators.min(10), Validators.max(18)]]
    }),
    prices: this._formBuilder.group({
      amit: [0, [Validators.required, Validators.min(1)]],
      nilve: [0, [Validators.required, Validators.min(1)]],
      yeled: [0, [Validators.required, Validators.min(0)]],
      tinok: [0, [Validators.required, Validators.min(0)]],
      visa: [0, Validators.min(0)],
      single: [0, Validators.min(0)],
      tip: [0, Validators.min(0)]
    }),
    roomSettings: this._formBuilder.group({
      roomType: [0, [Validators.required, Validators.min(1)]],
      availableRooms: [20, [Validators.required, Validators.min(1)]],
      roomsHamtana: [50, [Validators.required, Validators.min(1)]]
    }),
    registrationSettings: {
      fromDate: ["", Validators.required], // TODO: add date validation
      toDate: ["", Validators.required], // TODO: add date validation
      fromTime: ["", Validators.required]
    }
  });

  


  nofashimTentativim: INofesh[];
  selectedNofeshId: number;
  selectedNofesh: INofesh;

  readonly acceptedExtensions: string = ".xlsx, .xls";
  nofashimFile: File;


  constructor(
    private _formBuilder: FormBuilder,
    private _nofeshService: NofeshService

    ,private _http: HttpClient
  ) { }

  testForm() { console.log(this.newNofesh) };

  ngOnInit() {
    this._getData();
  }

  
  
  private _getData(): void
  {
    
  }

  fileSelected(event)
  {
    console.log(event);
    if(!(event.target.value).includes(".xls") && !(event.target.value).includes(".xlsx"))
    {
      // TODO: show error

      console.error("Invalid file extension");
      return;
    }

    this.nofashimFile = event.target.files[0];
  }

  uploadExcelFile()
  {
    console.log(this.nofashimFile);
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";


    // reset this.nofashimFile after upload
  }



  private _addAdditionalPricesNofeshPnim(): void
  {
    const nofeshPnimAdditionalPrices: FormGroup = this._formBuilder.group({
      deletMekasheret: [0, Validators.min(0)],
      zugYeledAndTinok: [0, Validators.min(0)],
      familyRoom: [0, Validators.min(0)],
      twoKidsSeperateRoom: [0, Validators.min(0)],
      threeKidsSeperateRoom: [0, Validators.min(0)],
      secondYeledInRoom: [0, Validators.min(0)]
    });
    this.newNofesh.get("prices")["nofeshPnimAdditionalPrices"] = nofeshPnimAdditionalPrices;
  }


}
